"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggersChangedNotifyType = exports.TriggerCallBackType = exports.TriggerModeUI = exports.TriggerPriceType = exports.TriggerType = exports.TriggerOrderStatus = void 0;
var TriggerOrderStatus;
(function (TriggerOrderStatus) {
    TriggerOrderStatus["OPEN"] = "open";
    TriggerOrderStatus["CANCELED"] = "canceled";
    TriggerOrderStatus["CLOSED"] = "closed";
})(TriggerOrderStatus = exports.TriggerOrderStatus || (exports.TriggerOrderStatus = {}));
var TriggerType;
(function (TriggerType) {
    /**大于等于*/
    TriggerType["GREATER_EQUAL"] = "GREATER_EQUAL";
    /**小于等于 */
    TriggerType["LESS_EQUAL"] = "LESS_EQUAL";
    /**向上追踪 */
    TriggerType["TRAILING_UP_BACK"] = "TRAILING_UP_BACK";
    /**向下追踪 */
    TriggerType["TRAILING_DOWN_REV"] = "TRAILING_DOWN_REV";
})(TriggerType = exports.TriggerType || (exports.TriggerType = {}));
var TriggerPriceType;
(function (TriggerPriceType) {
    /**最后成交价*/
    TriggerPriceType["LAST_PRICE"] = "LASTPRICE";
    /**标记价格 */
    TriggerPriceType["MARK_PRICE"] = "MARKPRICE";
})(TriggerPriceType = exports.TriggerPriceType || (exports.TriggerPriceType = {}));
/**设置条件单时的模式 */
var TriggerModeUI;
(function (TriggerModeUI) {
    /**普通条件单 */
    TriggerModeUI["NORMAL"] = "NORMAL";
    /**止盈止损 */
    TriggerModeUI["TP_SL"] = "TP_SL";
    /**追踪出场 */
    TriggerModeUI["TRACK_BACK"] = "TRACK_BACK";
})(TriggerModeUI = exports.TriggerModeUI || (exports.TriggerModeUI = {}));
var TriggerCallBackType;
(function (TriggerCallBackType) {
    /**按价值：CALLBACK_RANGE */
    TriggerCallBackType["CALLBACK_RANGE"] = "CALLBACK_RANGE";
    /**按比率：CALLBACK_RATE */
    TriggerCallBackType["CALLBACK_RATE"] = "CALLBACK_RATE";
})(TriggerCallBackType = exports.TriggerCallBackType || (exports.TriggerCallBackType = {}));
/**TODO 新增通知类型 */
var TriggersChangedNotifyType;
(function (TriggersChangedNotifyType) {
})(TriggersChangedNotifyType = exports.TriggersChangedNotifyType || (exports.TriggersChangedNotifyType = {}));
